// Static nakshatra lookup table — gets the 1200-LOC data-cap.

export const NAKSHATRA_DATA: Record<
  string,
  { hi: string; ruler: string; deity: string; meaning: string }
> = {
  ashwini: {
    hi: "अश्विनी",
    ruler: "Ketu",
    deity: "Ashwini Kumaras",
    meaning: "Born of a female horse — symbolizes speed, healing, and new beginnings",
  },
  bharani: {
    hi: "भरणी",
    ruler: "Venus",
    deity: "Yama",
    meaning: "The bearer — represents restraint, transformation, and nurturing",
  },
  krittika: {
    hi: "कृत्तिका",
    ruler: "Sun",
    deity: "Agni",
    meaning: "The cutter — symbolizes purification, sharpness, and divine fire",
  },
  rohini: {
    hi: "रोहिणी",
    ruler: "Moon",
    deity: "Brahma",
    meaning: "The red one — represents growth, beauty, and fertility",
  },
  mrigashira: {
    hi: "मृगशिरा",
    ruler: "Mars",
    deity: "Soma",
    meaning: "The deer head — symbolizes searching, curiosity, and gentleness",
  },
  ardra: {
    hi: "आर्द्रा",
    ruler: "Rahu",
    deity: "Rudra",
    meaning: "The moist one — represents storms, renewal, and emotional depth",
  },
  punarvasu: {
    hi: "पुनर्वसु",
    ruler: "Jupiter",
    deity: "Aditi",
    meaning: "Return of light — symbolizes restoration, wisdom, and abundance",
  },
  pushya: {
    hi: "पुष्य",
    ruler: "Saturn",
    deity: "Brihaspati",
    meaning: "Nourisher — represents the most auspicious star for spiritual growth",
  },
  ashlesha: {
    hi: "आश्लेषा",
    ruler: "Mercury",
    deity: "Naga",
    meaning: "The entwiner — symbolizes mystical power, intuition, and kundalini",
  },
  magha: {
    hi: "मघा",
    ruler: "Ketu",
    deity: "Pitris",
    meaning: "The mighty — represents royal authority, ancestry, and tradition",
  },
  purva_phalguni: {
    hi: "पूर्व फाल्गुनी",
    ruler: "Venus",
    deity: "Bhaga",
    meaning: "Former reddish one — symbolizes love, creativity, and pleasure",
  },
  uttara_phalguni: {
    hi: "उत्तर फाल्गुनी",
    ruler: "Sun",
    deity: "Aryaman",
    meaning: "Latter reddish one — represents patronage, contracts, and friendship",
  },
  hasta: {
    hi: "हस्त",
    ruler: "Moon",
    deity: "Savitar",
    meaning: "The hand — symbolizes skill, craftsmanship, and dexterity",
  },
  chitra: {
    hi: "चित्रा",
    ruler: "Mars",
    deity: "Vishwakarma",
    meaning: "The brilliant — represents beauty, artistry, and divine architecture",
  },
  swati: {
    hi: "स्वाति",
    ruler: "Rahu",
    deity: "Vayu",
    meaning: "The sword — symbolizes independence, flexibility, and trade",
  },
  vishakha: {
    hi: "विशाखा",
    ruler: "Jupiter",
    deity: "Indra-Agni",
    meaning: "The forked — represents determination, purpose, and triumph",
  },
  anuradha: {
    hi: "अनुराधा",
    ruler: "Saturn",
    deity: "Mitra",
    meaning: "Following Radha — symbolizes devotion, friendship, and success abroad",
  },
  jyeshtha: {
    hi: "ज्येष्ठा",
    ruler: "Mercury",
    deity: "Indra",
    meaning: "The eldest — represents seniority, protection, and courage",
  },
  mula: {
    hi: "मूल",
    ruler: "Ketu",
    deity: "Nirrti",
    meaning: "The root — symbolizes investigation, destruction of ignorance, and foundation",
  },
  purva_ashadha: {
    hi: "पूर्वाषाढ़ा",
    ruler: "Venus",
    deity: "Apas",
    meaning: "Former invincible — represents invigoration, declaration, and confidence",
  },
  uttara_ashadha: {
    hi: "उत्तराषाढ़ा",
    ruler: "Sun",
    deity: "Vishvedevas",
    meaning: "Latter invincible — symbolizes final victory, leadership, and universal values",
  },
  shravana: {
    hi: "श्रवण",
    ruler: "Moon",
    deity: "Vishnu",
    meaning: "The listener — represents learning, connection, and divine hearing",
  },
  dhanishtha: {
    hi: "धनिष्ठा",
    ruler: "Mars",
    deity: "Vasus",
    meaning: "The wealthiest — symbolizes abundance, music, and prosperity",
  },
  shatabhisha: {
    hi: "शतभिषा",
    ruler: "Rahu",
    deity: "Varuna",
    meaning: "Hundred healers — represents healing, mysticism, and seclusion",
  },
  purva_bhadrapada: {
    hi: "पूर्व भाद्रपद",
    ruler: "Jupiter",
    deity: "Aja Ekapada",
    meaning: "Former blessed feet — symbolizes spiritual fire, penance, and transformation",
  },
  uttara_bhadrapada: {
    hi: "उत्तर भाद्रपद",
    ruler: "Saturn",
    deity: "Ahir Budhnya",
    meaning: "Latter blessed feet — represents deep wisdom, cosmic serpent, and spiritual depth",
  },
  revati: {
    hi: "रेवती",
    ruler: "Mercury",
    deity: "Pushan",
    meaning: "The wealthy — symbolizes nourishment, safe journeys, and completion",
  },
};

export function normalizeNakshatraKey(name: string): string {
  return name.toLowerCase().replace(/[\s-]+/g, "_");
}
